import {
  TPartnerExclusionFull,
  TPartnerExclusionFullMapped,
  TPartnerExclusionListItem,
  TPartnerExclusionReadable,
  TPartnerExclusionToSave,
} from 'onboarding/classes/models/partnerExclusion'
import { DateHelper } from 'onboarding/utils/dateHelper'

export const mapPartnerExclusionFull = (
  data: TPartnerExclusionFull
): TPartnerExclusionFullMapped => {
  const now = DateHelper.now()

  return {
    ...data,
    Created: data.Created ? DateHelper.convertServerISOToDate(data.Created) || now : now,
    Modified: data.Modified ? DateHelper.convertServerISOToDate(data.Modified) || now : now,
    ExpirationDate: data.ExpirationDate
      ? DateHelper.convertServerISOToDate(data.ExpirationDate)
      : null,
    StatusChangedDate: data.StatusChangedDate
      ? DateHelper.convertServerISOToDate(data.StatusChangedDate)
      : null,
  }
}

export const mapPartnerExclusionToSave = (
  full: TPartnerExclusionFullMapped
): TPartnerExclusionToSave => {
  const { EntryId, UID, Created, CreatedBy, Modified, ModifiedBy, ...data } = full

  return {
    ...data,
    CommunicationName: trimString(data.CommunicationName) || '',
    LegalName: trimString(data.LegalName) || '',
    Comments: trimString(data.Comments) || '',
    AddressLine1: trimString(data.AddressLine1),
    AddressLine2: trimString(data.AddressLine2),
    StateISO: trimString(data.StateISO),
    City: trimString(data.City),
    ZIPCode: trimString(data.ZIPCode),
    URL: trimString(data.URL),
    LocationId: trimString(data.LocationId),
    PartnerId: trimString(data.PartnerId),
    FirstName: trimString(data.FirstName),
    LastName: trimString(data.LastName),
    Email: trimString(data.Email),
    ExpirationDate: data.ExpirationDate || null,
    StatusChangedDate: data.StatusChangedDate || null,
    InactivationReason: trimString(data.InactivationReason),
  }
}

export const mapPartnerExclusionToListItem = (
  full: TPartnerExclusionFullMapped & TPartnerExclusionReadable
): TPartnerExclusionListItem => {
  const {
    EntryId,
    UID,
    CommunicationName,
    LegalName,
    LocationId,
    PartnerId,
    Status,
    CountryISO,
    Country,
    Created,
    StatusChangedDate,
    ExclusionReason,
    ExclusionReasonReadable,
  } = full

  return {
    EntryId,
    UID,
    CommunicationName,
    LegalName,
    LocationId,
    PartnerId,
    Status,
    CountryISO,
    Country,
    Created: DateHelper.convertDateToServerISO(Created),
    StatusChangedDate: StatusChangedDate
      ? DateHelper.convertDateToServerISO(StatusChangedDate)
      : null,
    ExclusionReason,
    ExclusionReasonReadable,
  }
}

const trimString = (value: string | null) => {
  if (!value) {
    return null
  }

  const trimmed = value.trim()

  return trimmed || null
}
